import React, { useEffect, useState } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from "../../../../utils/api/api";
import { color } from "../../../../utils/themes/color";
import { RedNotif, GreenNotif, FarsiDate } from "../../../../utils/utils";
import { Row, Col } from "antd";
import LOADING from "../../../../components/loading/loading";
import BUTTON from './../../../../components/buttons/button';
import SELECT from "../../../../components/select/select";


export default function Credit(props) {
    const userId = props.userId
    const [loading, setLoading] = useState({ 1: false, 2: false });
    const [validity, setValidity] = useState("")
    const [items, setItems] = useState([]);
    const [selected, setSelected] = useState(null);
    const [updater, setUpdater] = useState(1);


    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}users/get-validity-coach/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setLoading({ ...loading, 1: false })
                    setValidity(response.data.validity);
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                console.log("errot", error)
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [updater])

    useEffect(() => {
        Axios.get(`${url}settings/v1/package-list`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (response.data != null && response.data != undefined) {
                        console.log("res", response)
                        var x = [];
                        for (const iterator of response.data) {
                            x.push({
                                name: iterator.title + " " + iterator.price + " " + "تومان",
                                value: iterator._id
                            })
                        }
                        setItems(x)
                    }
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                console.log("errot", error)
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [])

    const extension = () => {
        if (selected != null) {
            setLoading({ ...loading, 2: true });
            let x = {
                "packageId": selected
            }
            Axios.post(`${url}users/add-validity-to-coach/${userId}`, x)
                .then((response) => {
                    if (response.status === 200 || response.status === 201) {
                        setLoading({ ...loading, 2: false })
                        GreenNotif(response.message)
                        setUpdater(updater + 1)
                        props.pager(4)
                    }
                    else {
                        RedNotif(response.message)
                        setLoading({ ...loading, 2: false })
                    }
                })
                .catch((error) => {
                    RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
                    setLoading({ ...loading, 2: false })

                });
        }
    }

    console.log(validity)

    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row >
                    <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={24}>
                        <p style={{ fontSize: "15px" }}>تاریخ اعتبار مربی :</p>
                        <br />
                        <p style={{ fontSize: "15px" }}>{validity ? FarsiDate(validity) : "فاقد اعتبار"}</p>
                    </Col>
                    <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={24}>
                        <SELECT
                            items={items}
                            value={selected}
                            click={(e) => setSelected(e)} />
                        <br /> <br /><br />  <br />

                    </Col>
                </Row>
                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON
                            text={"تمدید اعتبار مربی"}
                            event={(e) => extension(e)}
                            loading={loading[2]}
                            type={"submit"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(4)} text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }
}